module.exports = __webpack_public_path__ + "img/reset_light_strip_step_3.c41aea70.gif";